import { render } from "./CadastrarVideo.vue?vue&type=template&id=4f2c7af5&scoped=true"
import script from "./CadastrarVideo.vue?vue&type=script&lang=js"
export * from "./CadastrarVideo.vue?vue&type=script&lang=js"

import "./CadastrarVideo.vue?vue&type=style&index=0&id=4f2c7af5&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2c7af5"]])

export default __exports__